export const ICONS = {
  // Navigation & UI
  CHEVRON_LEFT: '/images/icons/icon-chevron-left.svg',
  CHEVRON_DOWN: '/images/icons/icon-chevron-down.svg',
  CHEVRON_DOWN_DARK: '/images/icons/icon-chevron-down-dark.svg',
  CHEVRON_RIGHT: '/images/icons/icon-chevron-right.svg',
  SEARCH: '/images/icons/icon-search.svg',
  CLOSE: '/images/icons/icon-close.svg',
  MENU: '/images/icons/icon-menu.svg',
  ARROW_RIGHT: '/images/icons/icon-arrow-right.svg',
  SUBMIT: '/images/icons/icon-submit.svg',
  SUBMIT_GREEN: '/images/icons/icon-submit-green.svg',
  ERR_CLOSE: '/images/icons/icon-error-close.svg',
  SUCCESS_CLOSE: '/images/icons/icon-success-close.svg',
  VIEW_FORMS: '/images/icons/icon-view-form.svg',
  SURVEY_COMPLETED: '/images/icons/icon-completed-survey-btn.svg',
  FORM_MODAL: '/images/icons/icon-form-modal.svg',
  // Authentication
  LOGOUT: '/images/icons/icon-logout.svg',
  USER_AVATAR: '/images/icons/user-avatar.svg',
  LOGIN_BTN: '/images/icons/icon-login-box.svg',
  LOGOUT_BTN: '/images/icons/icon-logout-btn.svg',
  LOGOUT_MODAL: '/images/icons/icon-logout-modal.svg',
  SYNC_YELLOW: '/images/icons/sync-yellow.svg',

  // Actions
  VIEW: '/images/icons/eye-view.svg',
  DELETE: '/images/icons/icon-delete.svg',
  EDIT: '/images/icons/icon-edit.svg',
  TRASH: '/images/icons/icon-trash.svg',
  CHECK: '/images/icons/icon-check.svg',
  EYE: '/images/icons/icon-eye.svg',
  EYE_OFF: '/images/icons/icon-eye-off.svg',
  BACK: '/images/icons/icon-back.svg',
  TICK: '/images/icons/icon-tick.svg',
  TICK_GREEN: '/images/icons/icon-tick-green.svg',
  PLUS: '/images/icons/icon-plus.svg',
  EDIT_WHITE: '/images/icons/icon-edit-white.svg',
  DELETE_WHITE: '/images/icons/icon-delete-white.svg',
  SEND: '/images/icons/icon-send.svg',
  EMAIL: '/images/icons/icon-email.svg',
  REFRESH: '/images/icons/icon-refresh.svg',

  // Status & Alerts
  SUCCESS: '/images/icons/icon-success-alert.svg',
  ERROR: '/images/icons/icon-error-alert.svg',
  WARNING: '/images/icons/icon-warning.svg',
  INFO: '/images/icons/icon-info.svg',
  OFFLINE: '/images/icons/icon-offline.svg',
  ONLINE: '/images/icons/icon-online.svg',

  // Dashboard Stats Icons
  COMPLETED_SURVEY: '/images/icons/icon-completed-survey.svg',
  PENDING_SURVEY: '/images/icons/icon-pending-survey.svg',
  SYNC_STATUS: '/images/icons/icon-sync-status.svg',
  STORAGE: '/images/icons/icon-storage.svg',

  // Main Navigation
  DASHBOARD: '/images/icons/icon-dashboard.svg',
  FORMS: '/images/icons/icon-forms.svg',
  SYNC: '/images/icons/icon-sync.svg',
  SETTINGS: '/images/icons/icon-settings.svg',
  DATA: '/images/icons/icon-data.svg',
  CHAT: '/images/icons/icon-chat.svg',

  // Additional Icons
  ADD: '/images/icons/icon-add.svg',
  UPLOAD: '/images/icons/icon-upload.svg',
  SURVEY_SIDEBAR: '/images/icons/icon-survey-sidebar.svg',
  CHECKBOX: '/images/icons/icon-checkbox.svg',
  PROFILE_EDIT: '/images/icons/icon-profile-edit.svg',

  // Notifications
  NOTIFICATION: '/images/icons/notification.svg',

  // Location
  LOCATION_PIN: '/images/icons/icon-location-pin.svg',
};

export const LOGOS = {
  NGO: '/icons/terriqon/terriqon-dark.svg',
  LOGIN: '/icons/terriqon/terriqon-light.svg',
  NGO_BLUE: '/icons/terriqon/terriqon-light.svg',
  AUTH_LOGO: '/icons/terriqon/terriqon-fieldops-logo-dark.svg',
};

export const ILLUSTRATIONS = {
  SEARCH_NOT_FOUND: '/images/illustrations/not-found.svg',
  SUCCESS_TICK: '/images/illustrations/success-tick.svg',
  LOGIN_BG: '/images/illustrations/login-left-bg.svg',
  EMPTY_CHAT: '/images/illustrations/empty-chat.svg',
  CHAT_WALLPAPER: '/images/illustrations/chat-wallpaper.png',
};
